import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import intlProps from "../../../state/helpers/IntlProps"
import TaxSelect from "../../pricing/taxselect.component"
import QuoteService from "../../../state/quote/QuoteService"
import { InvoiceService } from "../../../state/invoice/services"
import OrderService from "../../../state/order/OrderService"
import PriceListService from "../../../state/price-list/PriceListService"
import { TaxDto } from "../../../state/tax/Tax"
import { Intl } from "../../../state/helpers/IntlProps"
import { QUOTE } from "../../../state/quote/Constants"
import { INVOICE } from "../../../state/invoice/Constants"
import { ORDER } from "../../../state/order/Constants"
import { PRICE_LIST } from "../../../state/price-list/Constants"
import { PRICING_TABLE } from "../../../utils/pricing/constants"
import PricingTableRowService from "../../../state/pricing/PricingTableRowService"

type OwnProps = {
    objectId: string,
    taxId: string,
    tax: TaxDto | null | undefined,
    itemIdList: Set<string>,
    onClose: () => void,
    mainTaxesOnly: boolean,
    billingMethod: string,
    mainObject: string,
    intl: Intl
}

const ItemBulkTaxQuoteComponent = (props: OwnProps & intlProps) => {
    const [taxId, setTaxId] = useState<string>(props.taxId)
    const [errorMsg, setErrorMsg] = useState<string>("")

    const applyTax = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        setErrorMsg("")
        let field = "taxId"
        switch (props.billingMethod) {
        case "monthly":
            field = "monthlyTaxId"
            break
        case "yearly":
            field = "yearlyTaxId"
            break
        }

        const payload = {
            [field]: taxId,
            rowIds: Array.from(props.itemIdList.values()),
        }

        let res
        switch (props.mainObject) {
        case QUOTE:
            res = QuoteService.applyBulkUpdate(props.objectId, payload)
            break
        case INVOICE:
            res = InvoiceService.applyBulkUpdate(props.objectId, payload)
            break
        case ORDER:
            res = OrderService.applyBulkUpdate(props.objectId, payload)
            break
        case PRICE_LIST:
            res = PriceListService.applyBulkUpdate(props.objectId, payload)
            break
        case PRICING_TABLE:
            res = PricingTableRowService.applyBulkUpdate(props.objectId, payload)
            break
        default:
            setErrorMsg(props.intl.formatMessage(props.intl["bulk_save_type_error"]))
            return
        }

        res.then((r) => {
            if (!r.error) {
                props.onClose()
            } else {
                setErrorMsg(r.error.message)
            }
        })
    }

    const handleTaxIdChange = (taxId: string) => {
        setTaxId(taxId)
    }

    const closeModals = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        props.onClose()
    }


    return (
        <Modal show={true} onHide={props.onClose} centered={true}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5 className="modal-title pb-0 mb-0 border-0" id="setDiscountModalLabel">
                        <FormattedMessage
                            id="quote.set_tax_modal.title"
                            defaultMessage="Tax"
                        />
                    </h5>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="container-fluid">
                    <TaxSelect
                        value={taxId}
                        onChange={handleTaxIdChange}
                        mainTaxesOnly={props.mainTaxesOnly}
                        tableTax={props.tax}
                    />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div className="text-danger">{errorMsg}</div>
                <button type="button" className="btn btn-secondary" onClick={closeModals}>
                    <FormattedMessage
                        id="quote.set_tax_modal.close_btn"
                        defaultMessage="Close"
                    />
                </button>
                <button type="button" className="btn btn-primary" onClick={applyTax}
                    disabled={taxId ? false : true}>
                    <FormattedMessage
                        id="quote.set_tax_modal.apply_discount_btn"
                        defaultMessage="Apply Tax"
                    />
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default ItemBulkTaxQuoteComponent


// WEBPACK FOOTER //
// ./src/common/quote/component/ItemBulkTaxQuoteComponent.tsx